import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './about-us.actions';

@Injectable()
export class AboutUsEffects {
    actions$ = inject(Actions);
    api = inject(DealerApiService);
    store = inject(Store);

    loadAboutUsContent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadAboutUsContent),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectSubDealerOrDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.api.getAboutUsContent(dealerSlug)).pipe(
                    switchMap((content) => [actions.loadAboutUsContentSuccess({ content })]),
                    catchError((error) => of(actions.loadAboutUsContentFailure({ error }))),
                ),
            ),
        );
    });

    loadAboutUsBelowTheFoldContent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadAboutUsBelowTheFoldContent),
            switchMap(() => [actions.loadAboutUsTeaser(), actions.loadJobOfferContent(), actions.loadEmployees()]),
        );
    });

    loadAboutUsTeasers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadAboutUsTeaser),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectSubDealerOrDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.api.getAboutUsTeasers(dealerSlug)).pipe(
                    switchMap((teasers) => [actions.loadAboutUsTeaserSuccess({ teasers })]),
                    catchError((error) => of(actions.loadAboutUsTeaserFailure({ error }))),
                ),
            ),
        );
    });

    loadJobOfferContent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadJobOfferContent),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectSubDealerOrDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.api.getJobOfferContent(dealerSlug)).pipe(
                    switchMap((jobOfferContent) => [actions.loadJobOfferContentSuccess({ jobOfferContent })]),
                    catchError((error) => of(actions.loadJobOfferContentFailure({ error }))),
                ),
            ),
        );
    });

    loadEmployeesContent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadEmployees),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectSubDealerOrDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.api.getAboutUsEmployees(dealerSlug)).pipe(
                    switchMap((employees) => [actions.loadEmployeesSuccess({ employees })]),
                    catchError((error) => of(actions.loadEmployeesFailure({ error }))),
                ),
            ),
        );
    });
}
